import { useFormik } from "formik";
import { Button, DataGrid, Grid, IconButton, IGridColDef, Stack, TextField } from "src/components";
import { useAppDispatch, useAppSelector } from "src/store";
import * as yup from "yup";
import { translate } from 'src/i18n/tHelper';
import HastalikTanimSlice from "src/store/Slices/GenelTanimlar/HastalikTanimSlice";
import VwHbsHataliktanimtaniDTO from "src/models/HastalikTanim/VwHbsHataliktanimtaniDTO";
import IslemTanimList from "./IslemTanimList";
import VwHbsHastaliktanimislemDTO from "src/models/HastalikTanim/VwHbsHastaliktanimislemDTO";
import { useHastalikTanimIslemEkleMutation } from "src/services/HastalikTanim/HastalikTanimApi";
import { helper } from "src/utils/helper";

interface IHastalikTaniIslemEkleProps { };
const path = 'pages|hataliktanim';
const HastalikTaniIslemEkle = (props: IHastalikTaniIslemEkleProps): JSX.Element => {
    const taniIslemList = useAppSelector(s=> s.hastalikTanim.taniIslemList);

    const [ekle, ekleState] = useHastalikTanimIslemEkleMutation();
    const dispatch = useAppDispatch();

    const columns: IGridColDef<VwHbsHastaliktanimislemDTO>[] = [
        {
            field:"islemkodu", headerName:translate(path,"İşlem Kodu"), width:100
        },
        {
            field:"islemadi", headerName:translate(path,"İşlem Adı"), minWidth:200, flex:1
        },
        {
            field:"adet", headerName:translate(path,"Adet"), width:80,
            renderCell:(params) => {
                return(
                    <TextField
                        id={params.row.id.toString()}
                        value ={params.row.adet}
                        onChange ={(e) => {
                            dispatch(HastalikTanimSlice.actions.setTaniIslemList(
                                taniIslemList.map((x) =>
                                        x.islemtanimId === params.row.islemtanimId ? {...x, adet: helper.objectToNumber(e.target.value)} : x
                                )
                            ))
                        }}
                        sx={{border: "none"}}
                    />
                )
            }
        },
        {
            field:"action", headerName:"", width:40,
            renderCell: (params) => {
                return(
                    <IconButton 
                        customType="delete" 
                        onClick={() => {
                            dispatch(HastalikTanimSlice.actions.setTaniIslemList(
                                taniIslemList.filter((e) => params.row.islemtanimId !== e.islemtanimId)
                            ))
                        }}
                    />
                )
            }
        }
    ]

    const ekleHandler = () => {
        ekle(taniIslemList)
        .unwrap()
        .then(() => {
            clearHandler();
            closeHandler();
        })
    }

    const closeHandler = () => {
        dispatch(HastalikTanimSlice.actions.setFetchParam(3));
        dispatch(HastalikTanimSlice.actions.setDialogParam(0));
    }

    const clearHandler = () => {
        dispatch(HastalikTanimSlice.actions.setTaniIslemList([]));
    }

    return (
        <>
            <Grid container>
                <Grid item md={12}>
                    <IslemTanimList />
                </Grid>
                <Grid item md={12}>
                    <DataGrid 
                        addHeaderColumn={
                            <Stack>
                                <Button 
                                    customType="clear"
                                    onClick={clearHandler}
                                />
                            </Stack>
                        }
                        columns={columns}
                        rows={taniIslemList || []}
                        sx={{height:"25vh"}}
                        getRowId={(e) => e.islemtanimId}
                    />
                </Grid>
                <Grid item md={6}>
                    <Button 
                        customType="save"
                        onClick={ekleHandler}
                        loading={ekleState.isLoading}
                    />
                </Grid>                
                <Grid item md={6}>
                    <Button 
                        customType="cancel"
                        onClick={closeHandler}
                    />
                </Grid>                
            </Grid>
        </>
    );
};

export default HastalikTaniIslemEkle;